"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoScheduleEventFilter = void 0;
/**
 予定なしのイベントを除外する
 1. Googleカレンダーでは終日予定が何故か**「予定なし」デフォルト**で作成されてしまうこと
 2. 終日予定の予約可否と設定が重複すること。
 から終日予定は予定なしの場合でも除外しない

        通常予定  終日予定
予定あり   　　 残す
予定なし   除外     残す
の形
 */
class NoScheduleEventFilter {
    static filter(events) {
        return events.filter((ev) => ev.isAllDay || ev.hasSchedule);
    }
}
exports.NoScheduleEventFilter = NoScheduleEventFilter;
//# sourceMappingURL=noScheduleEventFilter.js.map